import { memoize } from '@exodus/basic-utils';
const selectorFactory = (createAssetIncomingOrdersSelector) => memoize(({ assetNames, walletAccount }) => assetNames.length === 0
    ? () => false
    : (() => {
        const selectors = assetNames.map((assetName) => createAssetIncomingOrdersSelector({ assetName, walletAccount }));
        return (state) => selectors.some((selector) => selector(state).size > 0);
    })(), ({ assetNames, walletAccount }) => `${assetNames.join('.')}_${walletAccount}`);
const createAssetsHaveIncomingOrdersSelectorDefinition = {
    id: 'createAssetsHaveIncomingOrders',
    selectorFactory,
    dependencies: [{ selector: 'createAssetSourceIncomingOrders' }],
};
export default createAssetsHaveIncomingOrdersSelectorDefinition;
